import { normalize } from 'normalizr';

import api from '../../api';
import { schema } from '../../schema';
import { addEntities, removeEntity } from '../../actions';
import Format from '../../../lib/Format';
import Logger from '../../../lib/Logger';

// ACTION TYPES

export const SMS_LIST_REQUEST = 'SMS_LIST_REQUEST';
export const SMS_LIST_SUCCESS = 'SMS_LIST_SUCCESS';
export const SMS_LIST_FAILURE = 'SMS_LIST_FAILURE';
export const SMS_READ_REQUEST = 'SMS_READ_REQUEST';
export const SMS_READ_SUCCESS = 'SMS_READ_SUCCESS';
export const SMS_READ_FAILURE = 'SMS_READ_FAILURE';
export const SMS_UPDATE_REQUEST = 'SMS_UPDATE_REQUEST';
export const SMS_UPDATE_SUCCESS = 'SMS_UPDATE_SUCCESS';
export const SMS_UPDATE_FAILURE = 'SMS_UPDATE_FAILURE';
export const SMS_DELETE_REQUEST = 'SMS_DELETE_REQUEST';
export const SMS_DELETE_SUCCESS = 'SMS_DELETE_SUCCESS';
export const SMS_DELETE_FAILURE = 'SMS_DELETE_FAILURE';
export const SMS_FORM_DESTROY = 'SMS_FORM_DESTROY';
export const SMS_CSV_DOWNLOAD_REQUEST = 'SMS_CSV_DOWNLOAD_REQUEST';
export const SMS_CSV_DOWNLOAD_SUCCESS = 'SMS_CSV_DOWNLOAD_SUCCESS';
export const SMS_CSV_DOWNLOAD_FAILURE = 'SMS_CSV_DOWNLOAD_FAILURE';

// ACTION CREATORS

export function smsListRequest(page, limit, order, filter) {
  Logger.log(
    'debug',
    `[smses.actions] smsListRequest(${page}, ${limit}, ${order}, %j)`,
    filter
  );
  return {
    type: SMS_LIST_REQUEST,
    page: page,
    limit: limit,
    order: order,
    filter: filter,
  };
}

export function smsListSuccess(data) {
  Logger.log('debug', `[smses.actions] smsListSuccess(%j)`, data);
  return {
    type: SMS_LIST_SUCCESS,
    page: data.page,
    limit: data.limit,
    order: data.order,
    result: data.result,
    total: data.total,
    receivedAt: Date.now(),
  };
}

export function smsListFailure(error) {
  Logger.log('debug', `[smses.actions] smsListFailure(%j)`, error);
  return {
    type: SMS_LIST_FAILURE,
    error: error,
  };
}

export function smsReadRequest(id) {
  Logger.log('debug', `[smses.actions] smsReadRequest(${id})`);
  return {
    type: SMS_READ_REQUEST,
    id: id,
  };
}

export function smsReadSuccess(data) {
  Logger.log('debug', `[smses.actions] smsReadSuccess(%j)`, data);
  return {
    type: SMS_READ_SUCCESS,
    id: data.id,
    receivedAt: Date.now(),
  };
}

export function smsReadFailure(error) {
  Logger.log('debug', `[smses.actions] smsReadFailure(%j)`, error);
  return {
    type: SMS_READ_FAILURE,
    error: error,
  };
}

export function smsUpdateRequest(id, data) {
  Logger.log('debug', `[smses.actions] smsUpdateRequest(${id}, %j)`, data);
  return {
    type: SMS_UPDATE_REQUEST,
  };
}

export function smsUpdateSuccess(data) {
  Logger.log('debug', `[smses.actions] smsUpdateSuccess(%j)`, data);
  return {
    type: SMS_UPDATE_SUCCESS,
    id: data.id,
    receivedAt: Date.now(),
  };
}

export function smsUpdateFailure(error) {
  Logger.log('debug', `[smses.actions] smsUpdateFailure(%j)`, error);
  return {
    type: SMS_UPDATE_FAILURE,
    error: error,
  };
}

export function smsDeleteRequest(id) {
  Logger.log('debug', `[smses.actions] smsDeleteRequest(${id})`);
  return {
    type: SMS_DELETE_REQUEST,
    id: id,
  };
}

export function smsDeleteSuccess(id) {
  Logger.log('debug', `[smses.actions] smsDeleteSuccess(${id})`);
  return {
    type: SMS_DELETE_SUCCESS,
    id: id,
  };
}

export function smsDeleteFailure(error) {
  Logger.log('debug', `[smses.actions] smsDeleteFailure(%j)`, error);
  return {
    type: SMS_DELETE_FAILURE,
    error: error,
  };
}

export function smsFormDestroy(formState = null) {
  Logger.log('debug', `[smses.actions] smsFormDestroy(%j)`, formState);
  return {
    type: SMS_FORM_DESTROY,
    form: formState,
  };
}

export function smsCSVDownloadRequest(order, filter) {
  Logger.log('debug', `[state.smses.actions] smsCSVDownloadRequest()`);
  return {
    type: SMS_CSV_DOWNLOAD_REQUEST,
    order: order,
    filter: filter,
  };
}

export function smsCSVDownloadSuccess() {
  Logger.log('debug', `[state.smses.actions] smsCSVDownloadSuccess()`);
  return {
    type: SMS_CSV_DOWNLOAD_SUCCESS,
  };
}

export function smsCSVDownloadFailure() {
  Logger.log('debug', `[state.smses.actions] smsCSVDownloadFailure()`);
  return {
    type: SMS_CSV_DOWNLOAD_FAILURE,
  };
}

// API THUNK ACTION CREATORS

export function loadSmses(
  page = 1,
  limit = 10,
  order = null,
  filter = null,
  cb = function () {}
) {
  Logger.log(
    'debug',
    `[smses.actions] loadSmses(${page}, ${limit}, ${order}, %j, ###)`,
    filter
  );

  return async function (dispatch) {
    dispatch(smsListRequest(page, limit, order, filter));

    // call API
    const response = await api.getSmses(page, limit, order, filter);
    let success = false;

    // get smses list success
    if (200 === response.get('status')) {
      Logger.log(
        'info',
        `Get API smses list success. Page: ${page}, Limit: ${limit}, Order: ${order}.`
      );

      const normalizedEntities = normalize(response.getIn(['data', 'smses']), [
        schema.sms,
      ]);
      const data = {
        page: response.getIn(['data', 'page']),
        limit: response.getIn(['data', 'limit']),
        order: order,
        total: response.getIn(['data', 'total']),
        result: normalizedEntities.result,
      };

      dispatch(addEntities(normalizedEntities));
      dispatch(smsListSuccess(data));
      success = true;
    } else if (1 === page && 204 === response.get('status')) {
      Logger.log(
        'info',
        `Get API smses success [empty]. Page: ${page}, Limit: ${limit}, Order: ${order}.`
      );
      const data = {
        page: page,
        limit: limit,
        order: order,
        total: 0,
        result: [],
      };
      dispatch(smsListSuccess(data));
      success = true;

      // get smses list failure
    } else {
      Logger.log(
        'info',
        `Get API smses list failure. Page: ${page}, Limit: ${limit}, Order: ${order}.`
      );
      dispatch(smsListFailure(response.getIn(['data', 'error'])));
    }

    // callback function
    cb(success);
  };
}

export function loadSms(id, cb = function () {}) {
  Logger.log('debug', `[smses.actions] loadSms(${id}, ###)`);

  return async function (dispatch) {
    dispatch(smsReadRequest(id));

    // call API
    const response = await api.getSms(id);
    let success = false;

    // get sms success
    if (200 === response.get('status')) {
      Logger.log('info', `Get API sms success. ID: ${id}.`);

      const normalizedEntities = normalize(
        [response.getIn(['data', 'sms'])],
        [schema.sms]
      );
      const data = {
        id: response.getIn(['data', 'sms', 'id']),
      };

      dispatch(addEntities(normalizedEntities));
      dispatch(smsReadSuccess(data));
      success = true;

      // get sms failure
    } else {
      Logger.log('info', `Get API sms failure. ID: ${id}.`);
      dispatch(smsReadFailure(response.getIn(['data', 'error'])));
    }

    // callback function
    cb(success);
  };
}

export function updateSms(id, data, cb = function () {}) {
  Logger.log('debug', `[smses.actions] updateSms(${id}, %j, ###)`, data);

  return async function (dispatch) {
    dispatch(smsUpdateRequest(id, data));

    // call API
    const response = await api.putSms(id, data);
    let success = false;

    // put sms success
    if (200 === response.get('status')) {
      Logger.log('info', `PUT API sms success. User: ${id}.`);

      const normalizedEntities = normalize(
        [response.getIn(['data', 'sms'])],
        [schema.sms]
      );
      const data = {
        id: response.getIn(['data', 'sms', 'id']),
      };

      dispatch(addEntities(normalizedEntities));
      dispatch(smsUpdateSuccess(data));
      success = true;

      // get sms failure
    } else {
      Logger.log('info', `PUT API sms failure. ID: ${id}.`);
      dispatch(smsUpdateFailure(response.getIn(['data', 'error'])));
    }

    // callback function
    cb(success);
  };
}

export function deleteSms(id, cb = function () {}) {
  Logger.log('debug', `[smses.actions] deleteSms(${id}, ###)`);

  return async function (dispatch) {
    dispatch(smsDeleteRequest(id));

    // call API
    const response = await api.deleteSms(id);
    let success = false;

    // delete sms success
    if (204 === response.get('status')) {
      Logger.log('info', `DELETE API sms success. ID: ${id}.`);

      dispatch(removeEntity({ entityType: 'smses', id: id }));
      dispatch(smsDeleteSuccess(id));
      success = true;

      // get sms failure
    } else {
      Logger.log('info', `DELETE API sms failure. ID: ${id}.`);
      dispatch(smsDeleteFailure(response.getIn(['data', 'error'])));
    }

    // callback function
    cb(success);
  };
}

export function downloadSmsesCSV(
  order = null,
  filter = null,
  cb = function () {}
) {
  Logger.log(
    'debug',
    `[state.smses.actions] downloadSmsesCSV(${order}, ${filter}, ###)`
  );

  return async function (dispatch) {
    dispatch(smsCSVDownloadRequest(order, filter));

    // call API
    const response = await api.getSmsesCSV(order, filter);

    // get smses CSV success
    if (200 === response.get('status')) {
      Logger.log('info', `Get API smses CSV success. Order: ${order}`);
      const now = new Date();

      // trigger browser download
      const url = window.URL.createObjectURL(new Blob([response.get('data')]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute(
        'download',
        `cv-smses-${Format.date(now, 'YYYY-MM-DDTHHmm')}.csv`
      );
      document.body.appendChild(link);
      link.click();

      dispatch(smsCSVDownloadSuccess());

      // get smses CSV failure
    } else {
      Logger.log('info', `Get API smses CSV failure.`);
      dispatch(smsCSVDownloadFailure());
    }

    // callback function
    cb();
  };
}

Logger.log('silly', `smses.actions loaded.`);
